import React from "react";
import "./style.css";

export default ({ image, alt }) => (
  <React.Fragment>
    <div className="logo-block-wrapper">
      <img src={ image } alt={ alt }  className="logo-block-image" /> 
    </div>
  </React.Fragment>
)